export const genres = [
  {
    key: "action",
    name: "动作片",
    icon: "ri-sword-line",
    desc: "拳拳到肉的打斗、惊险刺激的追车与爆破场面，动作片用最直接的视听冲击带来肾上腺素飙升的观影体验。",
  },
  {
    key: "comedy",
    name: "喜剧片",
    name2: "喜剧",
    icon: "ri-emotion-happy-line",
    desc: "轻松诙谐的桥段与妙语连珠的台词，喜剧片让你在欢笑中释放压力，是全家共赏的治愈之选。",
  },
  {
    key: "scifi",
    name: "科幻片",
    icon: "ri-rocket-2-line",
    desc: "从星际远征到未来都市，科幻片用大胆的想象与震撼的视效，探讨科技、时间与人类命运的宏大命题。",
  },
  {
    key: "romance",
    name: "爱情片",
    icon: "ri-heart-3-line",
    desc: "怦然心动的相遇、刻骨铭心的别离，爱情片细腻描摹人与人之间最柔软也最动人的情感。",
  },
  {
    key: "suspense",
    name: "悬疑片",
    icon: "ri-question-mark",
    desc: "层层反转的线索与步步紧逼的真相，悬疑片让你全程屏住呼吸，直到最后一刻才恍然大悟。",
  },
  {
    key: "horror",
    name: "恐怖片",
    icon: "ri-ghost-line",
    desc: "阴暗的角落、未知的低语，恐怖片用氛围与惊吓挑战你的心理极限，胆小者请谨慎观看。",
  },
  {
    key: "drama",
    name: "剧情片",
    icon: "ri-book-open-line",
    desc: "聚焦平凡人的不凡人生，剧情片以扎实的叙事与丰满的人物，折射现实生活的温度与力量。",
  },
  {
    key: "animation",
    name: "动画片",
    icon: "ri-magic-line",
    desc: "天马行空的想象与温暖治愈的故事，动画片不仅属于孩子，也为每个心怀童真的大人保留一片奇幻天地。",
  },
  {
    key: "war",
    name: "战争片",
    icon: "ri-shield-star-line",
    desc: "炮火纷飞的战场与家国情怀的抉择，战争片在宏大场面中拷问人性，铭记历史的沉重。",
  },
  {
    key: "crime",
    name: "犯罪片",
    icon: "ri-police-badge-line",
    desc: "黑帮、警匪与法外之地，犯罪片游走于道德边缘，揭开光鲜都市背后的暗流涌动。",
  },
];

export const regions = ["中国大陆", "美国", "英国", "韩国", "日本", "中国香港"];

export const decades = ["2025", "2024", "2023", "2022", "2021", "2020及以前"];

export const statusList = ["高清", "正片", "抢先版"];